export const GET_LEARNING_CONTENTS = 'GET_LEARNING_CONTENTS';
export const LEARNING_CONTENT_LOADING = 'LEARNING_CONTENT_LOADING';
export const GET_LEARNING_CONTENT = 'GET_LEARNING_CONTENT';
export const UPDATE_LEARNING_CONTENT = 'UPDATE_LEARNING_CONTENT';
export const ADD_LEARNING_CONTENT = 'ADD_LEARNING_CONTENT';
export const DELETE_LEARNING_CONTENT = 'DELETE_LEARNING_CONTENT';
